import React from 'react';
import { Dialog, DialogTitle, DialogActions, Button } from '@mui/material';

const DeleteModal = ({ isOpen, title, onClose, onConfirm }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      PaperProps={{
        sx: { width: 400, borderRadius: 2, p: 2 }
      }}
    >
      <DialogTitle id="delete-dialog-title" sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem' }}>
        {title}
      </DialogTitle>

      <DialogActions sx={{ justifyContent: 'center', gap: 2 }}>
        <Button variant="contained" color="error" onClick={onConfirm} sx={{ px: 4, py: 1 }}>
          Confirm
        </Button>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: '#e0e0e0',
            color: 'black',
            px: 4,
            py: 1,
            '&:hover': { backgroundColor: '#d5d5d5' }
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteModal;
